<div class="loader-overlay">
  <div class="loader-content">
    <div class="spinner">
      <div class="inner-circle"></div>
      <div class="orbit"></div>
    </div>
    <p class="loader-text">Loading...</p>
  </div>
</div>
